import { useEffect } from 'react'
import { useRecoilValue } from 'recoil'
import { applicationTypeAtom } from '@/atoms/globalAtoms'
import { M3 } from '@messenger/consts'

/**
 * Hook to dynamically update the document title and favicon based on application type
 * - M3: "M3 Designer" with M3 logo
 * - MDL: "My Designer Lab" with MDL logo
 */
export const useDocumentTitle = () => {
  const applicationType = useRecoilValue(applicationTypeAtom)

  useEffect(() => {
    const isM3 = applicationType === M3
    const title = isM3 ? 'M3 Designer' : 'My Designer Lab'
    const faviconPath = isM3 ? '/m3-favicon.svg' : '/favicon.ico'

    // Update title
    document.title = title

    // Update favicon
    let favicon = document.querySelector(
      "link[rel~='icon']",
    ) as HTMLLinkElement | null

    if (!favicon) {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      document.head.appendChild(favicon)
    }

    favicon.href = faviconPath
  }, [applicationType])
}
